import request from "@/utils/request";

/**
 * @param {object} body
 * @param {string} body.feedbackType 'BUG' | 'SUGGESTION'
 * @param {string} body.content
 * @param {string[]} [body.imageUrls]
 * @param {string} [body.contact] 可选，手机号或邮箱
 */
export function submitFeedback(body) {
  return request.post("/api/feedback/submit", body);
}
